export const confirmationModalTypes = {
    NONE: 'none',
    EDIT: 'edit',
    COPY: 'copy',
    CHANGE_DISRUPTION_TYPE: 'changeDisruptionType',
    REMOVE_SELECTED_ENTITY: 'removeSelectedEntity',
    RESET_SELECTED_ENTITIES: 'resetSelectedEntities',
};

export const DIRECTIONS = {
    0: 'Inbound/Anticlockwise',
    1: 'Outbound/Clockwise',
};

export const DISRUPTION_STATUS = {
    IN_PROGRESS: 'in-progress',
    NOT_STARTED: 'not-started',
    DRAFT: 'draft',
    RESOLVED: 'resolved',
};
